import { AxiosResponse } from "axios";
import { apiClient } from "@apis/apiClient";
import {
  FavoriteEntityType,
  BulkFavoriteEntitiesResponse,
  FavoriteActionResponse,
  FavoriteIdsByType,
} from "../types/favorites";

export const favoritesAPI = {
  // Add to favorites
  add: (
    entityType: FavoriteEntityType,
    entityId: number | string
  ): Promise<AxiosResponse<FavoriteActionResponse>> => {
    return apiClient.post(`/rest/favorites/${entityType}/${entityId}`);
  },

  // Remove from favorites
  remove: (
    entityType: FavoriteEntityType,
    entityId: number | string
  ): Promise<AxiosResponse<FavoriteActionResponse>> => {
    return apiClient.delete(`/rest/favorites/${entityType}/${entityId}`);
  },

  // Toggle favorite status
  toggle: (
    entityType: FavoriteEntityType,
    entityId: number | string
  ): Promise<AxiosResponse<FavoriteActionResponse>> => {
    return apiClient.put(`/rest/favorites/toggle/${entityType}/${entityId}`);
  },

  // Get favorite entity IDs grouped by type. Pass an entityType to load just that
  // type; omit it to load all types in one call. Response is always keyed by type.
  getFavoriteEntityIds: (
    entityType?: FavoriteEntityType
  ): Promise<AxiosResponse<FavoriteIdsByType>> => {
    return apiClient.get("/rest/favorites/ids", {
      params: entityType ? { type: entityType } : undefined,
    });
  },

  // Get all favorite entities in one bulk call
  getAllFavoriteEntities: (): Promise<
    AxiosResponse<string | BulkFavoriteEntitiesResponse>
  > => {
    return apiClient.get("/rest/favorites/entities/bulk");
  },
};

export default favoritesAPI;
